export default function roundToEndOfDay(date) {
  const roundedDate = new Date(date);
  roundedDate.setHours(23, 59, 59, 999);
  return roundedDate;
}
